import { Permission } from '@cims-online/shared'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useSoftRemoveCasSubtypeMutation } from 'schema'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  CASSubtype,
  useSubtypesTableContext,
} from '../../../../SubtypesTableContext'
import { DefaultMutationHookOptions } from 'utils/defaults'

export function useRemoveOptions(): RemoveRowActionOptions<CASSubtype> {
  const { refetch } = useSubtypesTableContext()
  const [remove] = useSoftRemoveCasSubtypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveCASSubtype: {
        subtype: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    disabled: ({ submittals }) =>
      !!submittals.length
        ? {
            message:
              'Submittal subtypes cannot be deleted if they are associated with one or more submittals',
          }
        : false,
    permission: Permission.RemoveRestoreCASSubtype,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
